import './payment.scoped.scss';

import { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getProduct } from 'src/services/checkout';
import { parse } from 'querystring';
import { useUser } from 'src/UserContext';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useModal } from 'src/ModalContext';
import { userProducts, userProductsCreated } from 'src/services/api';
import PaymentIamport from './Iamport';
import PaymentPaypal from './Paypal';
import { useAppDispatch } from 'src/AppContext';
import { PRODUCT_CATEGORY, PRODUCT_REGION } from 'src/constants/product';
import { isKorean } from 'src/services/util';

export default function Payment(): JSX.Element {
  const { isInit, isLogin, userInfo } = useUser();
  const { t } = useTranslation();
  const { showModal, errorModal } = useModal();
  const location = useLocation();
  const history = useCustomHistory();
  const qs = location.search.replace(/^[?]/gi, '');
  const { productId, payMethod } = parse(qs);
  const [isUsed, setIsUsed] = useState<boolean>(false);
  const [product, setProduct] = useState({} as CheckoutProductData);
  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
    };
  }, []);

  useEffect(() => {
    if (!isInit) return;

    if (isLogin) {
      (async function load() {
        // 유효한 상품 아이디 검색
        let seletedProduct: CheckoutProductData = {} as CheckoutProductData;
        let activatedProducts: ApiUserProductsActivatedResponse = {} as ApiUserProductsActivatedResponse;
        try {
          seletedProduct = await getProduct(productId as string);

          if (seletedProduct.category === PRODUCT_CATEGORY.BIXBY) {
            // @TODO for not launching bixby
            showModal({
              message: t('common/bixby_not_launch_message'),
              success: () => {
                history.replace('/', {}, ['afterPaymentEndpoint']);
                return;
              },
            });
            return;
          }
          console.log(seletedProduct);
          activatedProducts = await userProductsCreated();
          const { products } = await userProducts({
            category: seletedProduct.category,
          });
          setIsUsed(!!products.find(({ productId }) => +seletedProduct.id === productId));
        } catch (e) {
          errorModal(e);
        }

        if (activatedProducts.products && activatedProducts.products.length > 0) {
          const activatedProduct = activatedProducts.products.find((value) => value.category === seletedProduct.category);

          if (activatedProduct) {
            showModal({
              message: t('product/purchase/already_ticket_exists', {
                product: isKorean() ? activatedProduct.koName : activatedProduct.enName,
              }),
              success: () => {
                history.push('/');
              },
            });
            return;
          }
        }

        if (seletedProduct) {
          setProduct(seletedProduct);
        } else {
          showModal({
            message: t('payment/not_found_product'),
            success: () => {
              return;
            },
          });
        }
      })();
    }
  }, [isInit]);

  return userInfo.country === PRODUCT_REGION.KR ? (
    <PaymentIamport product={product} isUsed={isUsed} payMethod={(payMethod as string) || ''} />
  ) : (
    <PaymentPaypal product={product} isUsed={isUsed} />
  );
}
